import { getUserDataFromQStore } from '../../../../app/src/features/authentication/api/get/getUser';
import {
  proFlowStorage,
  piaFlowStorage,
  baloiseFlowStorage,
} from './localforageService';

function getStoreInstance(dbName) {
  switch (dbName) {
    case 'pro_flow':
      return proFlowStorage;
    case 'pia_flow':
      return piaFlowStorage;
    case 'baloise_flow':
      return baloiseFlowStorage;
    default:
      console.error('you forgot assign a database');
      break;
  }
}

export function newStorageEntry(dbName, id) {
  const lf = getStoreInstance(dbName);
  const { id: userId } = getUserDataFromQStore();
  if (!lf) return;
  return lf.setItem(id, {
    created_at: new Date().toISOString(),
    session_completed: false,
    user_id: userId,
    answers: [],
  });
}

export function retrieveStorageById(dbName, id) {
  const lf = getStoreInstance(dbName);
  if (!lf) return;
  return lf.getItem(id);
}

export async function patchStorage(dbName, id, payload) {
  const lf = getStoreInstance(dbName);
  if (!lf) return;
  const storedData = await lf.getItem(id);
  if (!storedData) return;
  const updatedData = Object.assign(storedData, payload);
  return lf.setItem(id, updatedData);
}
